import React from 'react';
import { useSelector } from 'react-redux';

import ControlWrapper from './components/ControlWrapper';
import { CONTROL_TYPES_WITH_PROPERTIES } from './constants/report-designer.constants';
import { getControl } from './getControl';
import { getControlProps } from './selectors/report-designer.selectors';

const DynamicControl = ({ id, ...rest }) => {
  const controlProps = useSelector((state) => getControlProps(state, { id }));

  const component = getControl({ ...controlProps, ...rest, id });

  return CONTROL_TYPES_WITH_PROPERTIES.includes(controlProps.controlType) ? (
    <ControlWrapper id={id} controlType={controlProps.controlType}>
      {component}
    </ControlWrapper>
  ) : (
    component
  );
};

export default DynamicControl;
